"use client";

import { useState } from "react";
import axiosInstance from "@libs/axios";
import { toast } from 'sonner';
import { useQueryClient } from "@tanstack/react-query";
import { apiUrl } from "@constants/url";

/**
 * Soft-deletes a doc pabean entry (hides it from the list; the CEISA filing
 * itself is untouched) and refreshes the doc-pabeans query.
 */
export default function useDeleteDocPabean() {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const deleteDocPabean = async (id: number): Promise<boolean> => {
    setLoading(true);
    try {
      await axiosInstance.delete(apiUrl.docPabean.delete(id));
      toast.success("Terhapus", { description: "Dokumen dihapus dari daftar" });
      await queryClient.invalidateQueries({ queryKey: ["doc-pabeans"] });
      return true;
    } catch (error: any) {
      toast.error("Error", { description: error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          "Gagal menghapus dokumen" });
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { deleteDocPabean, loading };
}
